import { type ReactElement, useId } from "react";
import styles from "./DougleyLogo.module.css";

function Logo(): ReactElement {
  const svgId = useId();
  const dougleyId = useId();
  const pathId = useId();

  return (
    <svg
      role="img"
      aria-label="Dougley Logo"
      className={styles.logo}
      width="150px"
      height="50px"
      viewBox="0 0 1460 500"
      version="1.1"
      id={svgId}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id={dougleyId}>
        <path
          id={pathId}
          d="m 925.19922,39.25 -34.5,184 -8.75,43.12891 -59.54883,-26.62891 -94,51.5 -46,27.5 43.5,21 55.5,-25 -38.5,62.5 -2.5,9 -37,-34 -33,-34 23.5,-58.5 46,-93.5 17.5,-31.5 7.5,42.5 36.5,-25 20,-12.5 -9,-58.5 -3.5,-30 -47.5,23.5 -47.5,17.5 -59,131.5 -27,66 -37.19727,18.14453 37.39649,-218.14453 -51.5,-21 -35.5,213.5 -7.5,60 -72.5,24.5 24.5,-156 8.5,-64.5 -50,-22.5 -20.5,126.5 -23,120.5 16.5,10.5 -31,18.5 48,33.5 47.5,-18.5 46.5,-23 -1.18474,10.10569 c 18.4843,-6.21776 33.31772,-11.36142 50.05385,-17.55282 l 3.13091,-11.55283 16,-6 -12.5,-16 5.5,-33.5 0.75,-4.37695 56.55078,59.87695 39,42.5 31,28.5 57,-27.5 h 3 l 28.5,-60.5 44,-71.5 32.63867,-15.85352 -18.83984,92.85352 -38.5,21 31,16.5 0.5,8 24.5,9 35,12 10,-43.5 19.5,-9.5 135.49996,-68 -54,-27 -91.99996,47 18,-115.5 20.5,-146 z m 304.30078,14 -150,60 47.5,23.5 6.5,-2.5 -13.5,68.5 -51.5,24.5 41.5,23.5 -2,10.5 -17,93.5 -73.5,35.5 70,30 53.5,-30 140.5,-69 -56.5,-22.5 -65.5,27.5 6,-66 3.5,-32 33,-19 66.5,-32 -25,-10 -24,-10 -40,17.5 -1.5,0.5 11,-62 19.5,-7.5 75,-34 z m 232.3008,12 -56,9 -37.5,134.5 -28,110 -6,-29.5 -15,-145.5 -54,3.5 10,92.5 14,103 44,6.5 -13.5,71.5 -11,64 45.5,26.5 26.5,-133.5 56.5,-228 z m -1129.50002,11.5 -47.5,27 -3.5,7.5 -46.5,82 -58.5,105.5 23.5,50.5 9,-0.5 46.5,65 14.5,27.5 35,-29 -3.5,-11 7,1 62,-124 45.5,-85.5 7,-2.5 -3.5,-4 18.5,-34 0.5,-25.5 -37.5,-10.5 -16,29 -4.5,-5.5 -44,-56 z M 161,86.25 l -85,29.5 -37,13.5 -4,10 -1.5,-8 -42.5,15.5 27.5,30 5,-1.5 -16,104 -14,110 -25.5,44 54,13.5 88.5,-136.5 125,-170.5 -35.5,-25.5 z m -0.5,53.5 -103.5,161.5 12.5,-137 z m 158.80078,5.5 42,42.5 -18.5,33 -70.5,134.5 -32.5,-51 -5.5,-7.5 1.5,-2.5 z"
          clipPath="url(#clipPath339)"
        />
      </g>
    </svg>
  );
}

export default Logo;
